import { useEffect, useState } from 'react';
import {
  AppShell,
  Text,
  useMantineTheme,
  Title as Title2,
  Aside,
  MediaQuery,
  Navbar,
  Header,
  Group,
  Paper,
  RingProgress,
  SimpleGrid,
  Center,
  Select,
  List,
  Anchor,
  createStyles,
  Switch,
  ColorSwatch
} from '@mantine/core';
import { IconArrowUpRight } from '@tabler/icons';
import { useViewportSize } from '@mantine/hooks';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler, BarElement } from "chart.js";
import { Line, Bar } from 'react-chartjs-2';
import { LayersControl, MapContainer, TileLayer, GeoJSON } from 'react-leaflet'
import L from "leaflet"

import shp from "shpjs";

// most current
import SME from "./data/data/removed/sme_oct_2024";
import TA from "./data/data/removed/ta_oct_2024";

import SME_aug_2024 from "./data/data/removed/sme_aug_2024";
import TA_aug_2024 from "./data/data/removed/ta_aug_2024";
//import ProtectedAreas from './data/data/protected_area';
import TA_Jul_2024 from "./data/data/removed/ta_may_2024";
import SME_Jul_2024 from "./data/data/removed/sme_july_2024";

import SME_may_2024 from "./data/data/removed/sme_may_2024";

import sme_march_2024 from "./data/data/removed/sme_march_2024";
import ta_march_2024 from "./data/data/removed/ta_march_2024";

import feb_sme_2024 from "./data/data/feb_smes";
import feb_ta_2024 from "./data/data/feb_ta";

import Jan_SME_2024 from './data/data/removed/jan_2024';
import Jan_TA_2024 from './data/data/removed/ta_jan_2024';
import EA from './data/data/east_africa';
//import ProtectedAreas from './data/data/protected_area';

import Sep_sme from './data/data/removed/september/sme_site1';
import Sep_ta from './data/data/removed/september/TA_SMES_Geocoded1';
import Oct_sme from './data/data/removed/october/sme_site';
import Oct_ta from './data/data/removed/october/TA_SMES_Geocoded';
import Nov_sme from './data/data/removed/Nov';
import Nov_ta from './data/data/removed/NOV_ta';
import dec_sme from './data/data/removed/December/sme_site';
import dec_ta from './data/data/removed/December/TA_SMES_Geocoded';
import jan_sme from "./data/data/removed/jan-2023/sme_site";
import feb_sme from './data/data/removed/feb-2023/sme_site';

import LeafletRuler from './LeafletRuler';
import sme_march_2023 from './data/data/removed/march-2023/sme_site';
import sme_april_2023 from "./data/data/removed/april_2023";
import sme_may_2023 from "./data/data/removed/may_2023";
import sme_june_2023 from "./data/data/removed/jun_2023";
import sme_july_2023 from "./data/data/removed/jul_2023";
import sme_august_2023 from "./data/data/removed/august_sme";
import sme_sep_2023 from "./data/data/removed/sep_sme";
import ta_sep_2023 from "./data/data/removed/sep_ta";
import sme_nov_2023 from "./data/data/removed/nov_2023";


const { PUBLIC_URL } = process.env; // set automatically from package.json:homepage

const useStyles = createStyles((theme) => ({
  body: {
    display: 'flex',
    alignItems: 'center',
  },

  track: {
    width: 40,
    height: 6,
    overflow: 'visible',
  },

  thumb: {
    width: 20,
    height: 20,
    left: -2,
    transition: 'background-color 100ms ease, left 100ms ease',

    'input:checked + * > &': {
      backgroundColor: theme.fn.primaryColor(),
    },
  },
  header: {
    paddingLeft: theme.spacing.md,
    paddingRight: theme.spacing.md,
    backgroundColor: theme.colors.teal[9]
  },

  inner: {
    height: 50,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  links: {
    [theme.fn.smallerThan('md')]: {
      display: 'none',
    },
  },

  search: {
    [theme.fn.smallerThan('xs')]: {
      display: 'none',
    },
  },

  link: {
    display: 'block',
    lineHeight: 1,
    padding: '8px 12px',
    borderRadius: theme.radius.sm,
    textDecoration: 'none',
    color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.colors.gray[7],
    fontSize: theme.fontSizes.sm,
    fontWeight: 500,

    '&:hover': {
      backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
    },
  },

  navbar: {
      paddingTop: 0,
    },
  
    section: {
      marginLeft: -theme.spacing.md,
      marginRight: -theme.spacing.md,
      marginBottom: theme.spacing.md,
  
    },
  
    searchCode: {
      fontWeight: 700,
      fontSize: 10,
      backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.colors.gray[0],
      border: `1px solid ${
        theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.colors.gray[2]
      }`,
    },
  
    mainLinks: {
      paddingLeft: theme.spacing.md - theme.spacing.xs,
      paddingRight: theme.spacing.md - theme.spacing.xs,
      paddingBottom: theme.spacing.md,
    },
  
    mainLink: {
      display: 'flex',
      cursor: 'text',
      alignItems: 'center',
      width: '100%',
      fontSize: theme.fontSizes.xs,
      padding: `8px ${theme.spacing.xs}px`,
      borderRadius: theme.radius.sm,
      fontWeight: 500,
      color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.colors.gray[7],
  
      '&:hover': {
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
        color: theme.colorScheme === 'dark' ? theme.white : theme.black,
      },
    },
  
    mainLinkInner: {
      display: 'flex',
      alignItems: 'center',
      flex: 1,
    },
  
    mainLinkIcon: {
      marginRight: theme.spacing.sm,
      color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[6],
    },
  
    mainLinkBadge: {
      padding: 0,
      width: 20,
      height: 20,
      pointerEvents: 'none',
    },
  
    collections: {
      paddingLeft: theme.spacing.md - 6,
      paddingRight: theme.spacing.md - 6,
      paddingBottom: theme.spacing.md,
    },
  
    collectionsHeader: {
      paddingLeft: theme.spacing.md + 2,
      paddingRight: theme.spacing.md,
      marginBottom: 5,
    },

    root: {
      position: 'relative',
      '& *': {
        cursor: 'pointer',
      },
    },
  
    collectionLink: {
      display: 'block',
      padding: `8px ${theme.spacing.xs}px`,
      textDecoration: 'none',
      cursor: 'text',
      borderRadius: theme.radius.sm,
      fontSize: theme.fontSizes.xs,
      color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.colors.gray[7],
      lineHeight: 1,
      fontWeight: 500,
  
      '&:hover': {
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
        color: theme.colorScheme === 'dark' ? theme.white : theme.black,
      },
    },

    animalBody: {
      paddingLeft: 54,
      paddingTop: theme.spacing.sm,
    },
}));

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    Title,
    Tooltip,
    Filler,
    Legend,
  );
  
  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
        position: 'top',
      },
  
      title: {
        display: false,
        text: 'Aceli',
      },
    },
  };


export default function Dashboard() {
  const { classes } = useStyles();
  const theme = useMantineTheme();
  const [opened, setOpened] = useState(false);
  const { height, width } = useViewportSize();
  const [sme, setSME] = useState(SME.features.length);
  const [ta, setTa] = useState(TA.features.length);

  const [protected_areas, setProtectedAreas] = useState(null);

  const [country_boundaries, setCountryBoundaries] = useState(null);

  useEffect(() => {
    const fetchShapefile = async () => {
      try{
        const geojson = await shp("./datasets/ProtectedAreas.zip");
        setProtectedAreas(geojson);
      } catch(error){
        console.error("Error loading shapefile", error)
      }
    }

    fetchShapefile();
  }, [])

  useEffect(() => {
    const fetchShapefile = async () => {
      try{
        const geojson = await shp("./datasets/CountryBoundaries.zip");
        setCountryBoundaries(geojson);
      } catch(error){
        console.error("Error loading shapefile", error)
      }
    }

    fetchShapefile();
  }, [])

  const [light, setLight] = useState(true);
  const [basemap, setBasemap] = useState(true);

  const [center, setCenter] = useState([-0.8, 34.2176]);
  const [zoom, setZoom] = useState(6)
  const [query, setQuery] = useState("");

  const [country, setCountry] = useState("All");

  const [ke, setKe] = useState(0);
  const [ug, setUg] = useState(0);
  const [tz, setTz] = useState(0);
  const [rw, setRw] = useState(0);
  const [bi, setBi] = useState(0);
  const [zam, setZam] = useState(0);

  const [ke1, setKe1] = useState(0);
  const [ug1, setUg1] = useState(0);
  const [tz1, setTz1] = useState(0);
  const [rw1, setRw1] = useState(0);
  const [bi1, setBi1] = useState(0);
  const [zam1, setZam1] = useState(0);

  const [ke2, setKe2] = useState(0);
  const [ug2, setUg2] = useState(0);
  const [tz2, setTz2] = useState(0);
  const [rw2, setRw2] = useState(0);
  const [bi2, setBi2] = useState(0);
  const [zam2, setZam2] = useState(0);

  const [ke3, setKe3] = useState(0);
  const [ug3, setUg3] = useState(0);
  const [tz3, setTz3] = useState(0);
  const [rw3, setRw3] = useState(0);
  const [bi3, setBi3] = useState(0);
  const [zam3, setZam3] = useState(0);

  const [month, setMonth] = useState("20");
  const [dataset, setDataset] = useState("all");
  
  const [data, setData]= useState({sme: SME, ta: TA});

  useEffect(() => {
    if(country === "All"){
      setCenter([-0.8, 34.2176]);
      setZoom(6)
    } else if(country === "Kenya"){
      setZoom(7)
      setCenter([0.14888585279976863, 37.67988684557366]);
    } else if(country === "Tanzania"){
      setZoom(7)
      setCenter([-6.425414138332401, 34.39274955465043]);
    } else if(country === "Uganda"){
      setZoom(7)
      setCenter([1.0715434069180727, 32.28295053622308]);
    } else if(country === "Rwanda"){
      setZoom(7)
      setCenter([-2.1699543515574877, 29.727029333349698]);
    } else if(country === "Burundi"){
      setZoom(7)
      setCenter([-3.5311999529748026, 29.760474243223367]);
    } else if(country === "Zambia"){
      setZoom(7);
      setCenter([-15.421507800527126, 28.334598355160548]);
    }
  }, [country])

  useEffect(() => {
    let a = 0;
    let b = 0;
    let c = 0;
    let d = 0;
    let zambia1 = 0;


    let e = 0;
    let f = 0;
    let g = 0;
    let h = 0;
    let zambia2 = 0;

    for(let i=0; i<data.sme.features.length; i++){
      let co = data.sme.features[i].properties.Country;

      switch(co){
        case "Kenya":
            a += 1;
            break;
        case "Tanzania":
            b += 1;
            break;
        case "Uganda":
            c += 1;
            break;
        case "Rwanda":
            d += 1;
            break;
        case "Zambia":
          zambia1 += 1;
          break;
        default:
          // do nothing
      }

    }

    setKe2((a / ke).toFixed(1));
    setUg2((c / ug).toFixed(1));
    setTz2((b / tz).toFixed(1));
    setRw2((d / rw).toFixed(1));
    setZam2((zambia2 / zam).toFixed(1));


    for(let i=0; i<data.ta.features.length; i++){
      let co = data.ta.features[i].properties.Country;

      switch(co){
        case "Kenya":
            e += 1;
            break;
        case "Tanzania":
            f += 1;
            break;
        case "Uganda":
            g += 1;
            break;
        case "Rwanda":
            h += 1;
            break;
        case "Zambia":
            zambia2 += 1;
            break;
        default:
          // do nothing
      }

    }

    setKe3((e / ke1).toFixed(1));
    setUg3((f / ug1).toFixed(1));
    setTz3((g / tz1).toFixed(1));
    setRw3((h / rw1).toFixed(1));
    setZam3((zambia2 / zam).toFixed(1));

  }, [data]);

  useEffect(() => {
    if(query !== ""){
        // let search in the current sme dataset;
        let found = false;
        let c = []
        for(let i=0; i<data.sme.features.length; i++){

            if(found){
                setZoom(15);
                setCenter(center);
                break;
            } else {
                let item = data.sme.features[i];

                if(item.properties.Loanee.toLowerCase() === query.toLowerCase()){
                    found = true;
                    c.push(item.properties.Latitude);
                    c.push(item.properties.Longitude);
                }
            }

        }
    } else {
        setZoom(6);
        setCenter([-0.8, 34.2176]);
    }
  }, [query]);

  useEffect(() => {
    if(month === "20"){
      setData({sme: SME, ta: TA});
    } else if(month === "19"){
        setData({sme: SME_aug_2024, ta: TA_aug_2024});
    } else if(month === "18"){
      setData({sme: SME_Jul_2024, ta: TA_Jul_2024});
    } else if(month === "17"){
      setData({sme: SME_may_2024, ta: TA_Jul_2024});
    } else if(month === "16"){
      setData({sme: sme_march_2024, ta: ta_march_2024});
    } else if(month === "15"){
      setData({sme: feb_sme_2024, ta: feb_ta_2024});
    } else if(month === "14"){
      setData({sme: Jan_SME_2024, ta: Jan_TA_2024});
    } else if(month === "13"){
      setData({sme: sme_nov_2023, ta: ta_sep_2023});
    } else if(month === "12"){
      setData({sme: sme_sep_2023, ta: ta_sep_2023});
    } else if(month === "11"){
      setData({sme: sme_august_2023, ta: dec_ta});
    } else if(month === "10"){
      setData({sme: sme_july_2023, ta: dec_ta});
    } else if(month === "9"){
      setData({sme: sme_june_2023, ta: dec_ta});
    } else if(month === "8"){
      setData({sme: sme_may_2023, ta: dec_ta});
    } else if(month === "7"){
      setData({sme: sme_april_2023, ta: dec_ta});
    } else if (month === "6"){
      setData({sme: sme_march_2023, ta: dec_ta});
    } else if (month === "5"){
      setData({sme: feb_sme, ta: dec_ta});
    } else if(month === "4"){
      setData({sme: jan_sme, ta: dec_ta});
    } else if(month === "3"){
      setData({sme: dec_sme, ta: dec_ta});
  } else if(month === "2"){
        setData({sme: Nov_sme, ta: Nov_ta});
  } else if(month === "1"){
        setData({sme: Oct_sme, ta: Oct_ta});
    } else {
        setData({sme: Sep_sme, ta: Sep_ta});
    }
  }, [month]);

  useEffect(() => {
    if(month === "19"){
      setData({sme: SME, ta: TA});
      setSME(SME.features.length);
      setTa(TA.features.length);
  } else if(month === "19"){
    setData({sme: SME_aug_2024, ta: TA_aug_2024});
    setSME(SME_aug_2024.features.length);
    setTa(TA_aug_2024.features.length);
  } else if(month === "18"){
    setData({sme: SME_Jul_2024, ta: TA_Jul_2024});
    setSME(SME_Jul_2024.features.length);
    setTa(TA_Jul_2024.features.length);
  } else if(month === "17"){
    setData({sme: SME_may_2024, ta: TA_Jul_2024});
    setSME(SME_may_2024.features.length);
    setTa(TA_Jul_2024.features.length);

  } else if(month === "16"){
    setData({sme: sme_march_2024, ta: ta_march_2024});
    setSME(sme_march_2024.features.length);
    setTa(ta_march_2024.features.length);

  } else if(month === "15"){
    setData({sme: feb_sme_2024, ta: feb_ta_2024});
    setSME(feb_sme_2024.features.length);
    setTa(feb_ta_2024.features.length);

  } else if(month === "14"){
    setData({sme: Jan_SME_2024, ta: Jan_TA_2024});
    setSME(Jan_SME_2024.features.length);
    setTa(Jan_TA_2024.features.length);

  } else if(month === "13"){
    //setData({sme: sme_nov_2023, ta: ta_sep_2023});
    setSME(sme_nov_2023.features.length);
    setTa(ta_sep_2023.features.length);

  } else if(month === "12"){
    //setData({sme: sme_sep_2023, ta: ta_sep_2023});
    setSME(sme_sep_2023.features.length);
    setTa(ta_sep_2023.features.length);

  } else if(month === "11"){
    //setData({sme: sme_august_2023, ta: dec_ta});
    setSME(sme_august_2023.features.length);
    setTa(dec_ta.features.length);

  } else if(month === "10"){
    //setData({sme: sme_july_2023, ta: dec_ta});
    setSME(sme_july_2023.features.length);
    setTa(dec_ta.features.length);

  } else if(month === "9"){
    //setData({sme: sme_june_2023, ta: dec_ta});
    setSME(sme_june_2023.features.length);
    setTa(dec_ta.features.length);

  } else if(month === "8"){
    //setData({sme: sme_may_2023, ta: dec_ta});
    setSME(sme_may_2023.features.length);
    setTa(dec_ta.features.length);

  } else if(month === "7"){
    //setData({sme: sme_april_2023, ta: dec_ta});
    setSME(sme_april_2023.features.length);
    setTa(dec_ta.features.length);

  } else if (month === "6"){
    //setData({sme: sme_march_2023, ta: dec_ta});
    setSME(sme_march_2023.features.length);
    setTa(dec_ta.features.length);

  } else if (month === "5"){
    //setData({sme: feb_sme, ta: dec_ta});
    setSME(feb_sme.features.length);
    setTa(dec_ta.features.length);

  } else if(month === "4"){
    //setData({sme: jan_sme, ta: dec_ta});
    setSME(jan_sme.features.length);
    setTa(dec_ta.features.length);

  } else if(month === "3"){
    //setData({sme: dec_sme, ta: dec_ta});
    setSME(dec_sme.features.length);
    setTa(dec_ta.features.length);

} else if(month === "2"){
      //setData({sme: Nov_sme, ta: Nov_ta});
      setSME(Nov_sme.features.length);
      setTa(Nov_ta.features.length);

  } else if(month === "1"){
      //setData({sme: Oct_sme, ta: Oct_ta});
      setSME(Oct_sme.features.length);
      setTa(Oct_ta.features.length);

  } else {
      setSME(Sep_sme.features.length);
      setTa(Sep_ta.features.length);

  }
  }, [month])

  useEffect(() => {
    let Cke = 0;
    let Cug = 0;
    let Ctz = 0;
    let Crw = 0;
    let Czam = 0;

    let Cke1 = 0;
    let Cug1 = 0;
    let Ctz1 = 0;
    let Crw1 = 0;
    let Czam1 = 0;

    let x = month === "20" ? SME : month === 19 ? SME_aug_2024 : month === "18" ? SME_Jul_2024  : month === "17" ? SME_may_2024 : month === "16" ? sme_march_2024 : month === "15" ? feb_sme_2024 : month === "14" ? Jan_SME_2024 : month === "13" ? sme_nov_2023 : month === "12" ? sme_sep_2023 : month === "11" ? sme_august_2023 : month === "10" ? sme_july_2023 : month === "9" ? sme_june_2023 : month === "8" ? sme_may_2023 : month === "7" ? sme_april_2023 : month === "6" ? sme_march_2023 : month === "5" ? feb_sme : month === "4" ? jan_sme : month === "3" ? dec_sme : month === "2" ? Nov_sme : month === "1" ? Oct_sme : Sep_sme;
    let y = month === "20" ? TA : month === 19 ? TA_aug_2024 :  month === "18" ? TA_Jul_2024  : month === "17" ? TA_Jul_2024 : month === "16" ? ta_march_2024 : month === "15" ? feb_ta_2024 : month === "14" ? Jan_TA_2024 : month === "13" ? ta_sep_2023 : month === "12" ? ta_sep_2023 : month === "11" ? dec_ta : month === "10" ? dec_ta : month === "9" ? dec_ta : month === "8" ? dec_ta : month === "7" ? dec_ta : month === "6" ? dec_ta : month === "5" ? dec_ta : month === "4" ? dec_ta : month === "3" ? dec_ta : month === "2" ? Nov_ta : month === "1" ? Oct_ta : Sep_ta;


    for(let i=0; i<x.features.length; i++){
        let item = x.features[i].properties.Country;

        switch(item){
            case "Kenya":
                Cke++;
                break;

            case "Uganda":
                Cug++;
                break;

            case "Tanzania":
                Ctz++;
                break;

            case "Rwanda":
                Crw++;
                break;

            case "Zambia":
              Czam++;
              break;

            default:
                // do nothing

        }
    };

    setKe(Cke);
    setUg(Cug);
    setTz(Ctz);
    setRw(Crw);
    setZam(Czam);

    for(let i=0; i<y.features.length; i++){
        let item = y.features[i].properties.Country;

        switch(item){
            case "Kenya":
                Cke1++;
                break;

            case "Uganda":
                Cug1++;
                break;

            case "Tanzania":
                Ctz1++;
                break;

            case "Rwanda":
                Crw1++;
                break;

            case "Zambia":
              Czam1++;
              break;

            default:
                // do nothing

        }
    };

    setKe1(Cke1);
    setUg1(Cug1);
    setTz1(Ctz1);
    setRw1(Crw1);
    setZam1(Czam1);

  }, [month])

  function ConsumptionChart(){
    const theme = useMantineTheme();

    const labels = ['KE', 'UG', 'TZ', 'RW', "ZM"];

    const consumptionData = {
        labels,
        datasets: [
          {
            label: 'Loans',
            lineTension: 0.4,
            data: [ke, ug, tz, rw, zam],
            borderColor: 'rgba(248, 148, 6, 1)',
            backgroundColor: 'rgba(248, 148, 6, 1)',
          },
          {
            label: 'TA',
            lineTension: 0.4,
            data: [ke1, ug1, tz1, rw1, zam1],
            borderColor: 'rgba(77, 5, 232, 1)',
            backgroundColor: 'rgba(77, 5, 232, 1)',
          }
        ],
      };
    return (
        <Bar options={options} data={consumptionData} />
    )
  }

  function PreviousChart(){
    const theme = useMantineTheme();

    console.log(sme_july_2023.features.length)

    const labels = ['9/2022', '10/22',"11/22", "12/22", "1/23", "2/23", "3/23", "4/23", "5/23", "6/23", "7/23", "8/23", "9/23", "11/23", "1/24", "2/24", "3/24", "5/24", "7/24", "8/24", "10/24" ];

    const consumptionData = {
        labels,
        datasets: [
          {
            label: 'Loans',
            lineTension: 0.4,
            data: [Sep_sme.features.length, Oct_sme.features.length, Nov_sme.features.length, dec_sme.features.length, jan_sme.features.length, feb_sme.features.length, sme_march_2023.features.length, sme_april_2023.features.length, sme_may_2023.features.length, sme_june_2023.features.length, sme_july_2023.features.length, 1053, 1146, sme_nov_2023.features.length, Jan_SME_2024.features.length, feb_sme_2024.features.length, sme_march_2024.features.length, SME_may_2024.features.length, SME_Jul_2024.features.length, SME_aug_2024.features.length, SME.features.length],
            borderColor: 'rgba(248, 148, 6, 1)',
            backgroundColor: 'rgba(248, 148, 6, 1)',
          },
          {
            label: 'TA',
            lineTension: 0.4,
            data: [Sep_ta.features.length, Oct_ta.features.length, Nov_ta.features.length, dec_ta.features.length, dec_ta.features.length, dec_ta.features.length, dec_ta.features.length, dec_ta.features.length,dec_ta.features.length,dec_ta.features.length,dec_ta.features.length, dec_ta.features.length, 410, 410, Jan_TA_2024.features.length, feb_ta_2024.features.length, ta_march_2024.features.length, TA_Jul_2024.features.length, TA_Jul_2024.features.length, TA_aug_2024.features.length, TA.features.length],
            borderColor: 'rgba(77, 5, 232, 1)',
            backgroundColor: 'rgba(77, 5, 232, 1)',
          }
        ],
      };
    return (
        <Line options={options} data={consumptionData} />
    )
  }

  function AverageChart(){
    const theme = useMantineTheme();

    const labels = ['Ke', 'Ug',"Tz", "Rw", "ZM"];

    const consumptionData = {
        labels,
        datasets: [
          {
            label: 'Loans',
            lineTension: 0.4,
            data: [ke2, ug2, tz2, rw2, zam2],
            borderColor: 'rgba(248, 148, 6, 1)',
            backgroundColor: 'rgba(248, 148, 6, 1)',
          },
          {
            label: 'TA',
            lineTension: 0.4,
            data: [ke3, ug3, tz3, rw3, zam3],
            borderColor: 'rgba(77, 5, 232, 1)',
            backgroundColor: 'rgba(77, 5, 232, 1)',
          }
        ],
      };
    return (
        <Line options={options} data={consumptionData} />
    )
  }

  const MapLayer = () => {
    return (
      <MapContainer style={{width: '100%', height: "80%", backgroundColor: light ? "white" : "black"}} center={center} zoom={zoom} scrollWheelZoom={true}>
      <LayersControl>
      {basemap ? (
      <>
  <LayersControl.BaseLayer checked={basemap} name='OSM'>
  <TileLayer
    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    url= { !light ? "https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png" : "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"}
  />
  </LayersControl.BaseLayer>
  <LayersControl.BaseLayer name='Satellite'>
  <TileLayer
    attribution='&copy; Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
    url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
  />
  </LayersControl.BaseLayer>
      </>
    ) : null}
      <LayersControl.Overlay checked name="Country Boundaries">
          {country_boundaries &&  <GeoJSON data={country_boundaries} style={(feature) => {
            return {
                fillOpacity: 1, opacity: 1, weight: 2, color: light ? "black" : 'white', fillColor: 'transparent'
            }
          }} />}
      </LayersControl.Overlay>
      {dataset === "0" || dataset === "all" ? (
      <LayersControl.Overlay checked name='SMEs Receiving Loans'>
      <GeoJSON data={data.sme} pointToLayer={(f, latLng) => {
      return new L.CircleMarker(latLng, {
          radius: 6.0, opacity: 1, color: 'white', weight: 1, fillOpacity: 1, fillColor: 'rgba(248, 148, 6, 1)'
      })
      }} onEachFeature={(feature, l) => {
      l.bindPopup("<table class='table table-bordered' ><tr><td><b> SME Number</td><td>"+feature.properties.SME_No +"</td></tr>\
      <tr><td><b> Lender</b></td><td>"+feature.properties.Lender+"</td></tr>\
      <tr><td><b> Loanee</b></td><td><b>"+feature.properties.Loanee+"</b></td></tr>\
      <tr><td><b> Value Chain</b></td><td>"+ feature.properties.Value_chain+"</td></tr>\
      <tr><td><b> Country</b></td><td>"+feature.properties.Country+"</td></tr>\
      <tr><td><b> District</b></td><td>"+feature.properties.District+"</td></tr>\
      <tr><td><b> Ward</b></td><td>"+feature.properties.Ward+"</td></tr>\
      <tr><td><b> Nearest Protected Area</b></td><td>"+feature.properties.Nearest+"</td><td>"+feature.properties.Nearest_Dist+"km</td></tr>\
      <tr><td><b> Second Protected Area</b></td><td>"+feature.properties.Second+"</td><td>"+feature.properties.Second_Dist+"km</td></tr>\
      <tr><td><b> Third Protected Area</b></td><td>"+feature.properties.Third+"</td><td>"+feature.properties.Third_Dist+"km</td></tr>\
      </table>")
      }} />
      </LayersControl.Overlay>
      ) : null}
      {dataset === "all" || dataset === "1" ? (
      <LayersControl.Overlay checked name='SMEs Receiving TA'>
      <GeoJSON data={data.ta} pointToLayer={(f, latLng) => {
      return new L.CircleMarker(latLng, {
          radius: 6.0, opacity: 1, color: 'white', weight: 1, fillOpacity: 1, fillColor: 'rgba(77, 5, 232, 1)'
      })
      }} onEachFeature={(feature, l) => {
      l.bindPopup("<table class='table table-bordered' ><tr><td><b> SME Number<b></td><td>"+feature.properties.No +"</td></tr>\
      <tr><td><b> Enterprise</b></td><td>"+feature.properties.Enterprise+"</td></tr>\
      <tr><td><b> Town</b></td><td>"+feature.properties.Town+"</td></tr>\
      <tr><td><b> Country</b></td><td>"+feature.properties.Country+"</td></tr>\
      <tr><td><b> Nearest Protected Area</b></td><td>"+feature.properties.Nearest1+"</td><td>"+feature.properties.Dist1+"km</td></tr>\
      <tr><td><b> Second Protected Area</b></td><td>"+feature.properties.Nearest2+"</td><td>"+feature.properties.Dist2+"km</td></tr>\
      <tr><td><b> Third Protected Area</b></td><td>"+feature.properties.Nearest3+"</td><td>"+feature.properties.Dist3+"km</td></tr>\
      </table>")
      }} />
      </LayersControl.Overlay>
      ) : null}
      <LayersControl.Overlay checked name="Protected Areas">
          {protected_areas &&           <GeoJSON data={protected_areas} style={(feature) => {
      return {
          fillOpacity: 1.0, weight: 0.1, color: 'white', fillColor: 'rgba(178,223,138,1.0)'
      }
    }} onEachFeature={(feature, layer) => {
      layer.bindPopup("<table><tr><td><b>Name:</b>"+feature.properties.NAME+"</td></tr>\
      <tr><td><b>Designation:</b>"+feature.properties.DESIG+"</td></tr>\
      <tr><td><b>Status:</b>"+feature.properties.STATUS+"</td></tr></table>")
    }} />}
      </LayersControl.Overlay>
      </LayersControl>
      <LeafletRuler />
  </MapContainer>
    )
  }

  return (
    <AppShell
      styles={{
        main: {
            background: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.colors.gray[0],
        },
      }}
      navbarOffsetBreakpoint="sm"
      asideOffsetBreakpoint="sm"
      header={
        <Header height={50} className={classes.header}>
            <div className={classes.inner}>
              <Group>
                <Title2 color="#ffffff" order={4}>Aceli Africa SMEs Distribution</Title2>
              </Group>
              <Anchor href="https://aceliafrica.org" target="_blank" color="white" style={{textDecoration: "underline"}}>About Aceli Africa <IconArrowUpRight size={16} /></Anchor>
            </div>
        </Header>
      }
      aside={
        <MediaQuery smallerThan="sm" styles={{ display: 'none' }}>
          <Aside p="md" hiddenBreakpoint="sm" width={{ sm: 300, lg: 300 }}>
            <Group mb={10} p="md">
              <Switch checked={light} onChange={(e) =>{
                  setLight(e.target.checked)
                  setBasemap(true)
              }} label={light ? "Turn OFF light map theme" : "Turn ON light map theme"} classNames={classes} />
            </Group>
            <Group mb={10} p="md">
              <Switch checked={basemap} onChange={(e) =>{setBasemap(e.target.checked)}} label={basemap ? "Turn OFF basemap" : "Turn ON basemap"} classNames={classes} />
            </Group>
            <Select label="Display SMEs by country" data={[{label: "Kenya",value: "Kenya"}, {label:"Uganda", value: "Uganda"}, {label:"Tanzania", value: "Tanzania"}, {label:"Rwanda", value: "Rwanda"}, {label:"Burundi", value: "Burundi"}, {label: "Zambia", value: "Zambia"}, {label:"All", value: "All"}]} value={country} onChange={(val) => {setCountry(val)}} mb="md" />

                <Select mb="md" label='Display data for:' value={month} onChange={(val) => {setMonth(val)}} data={[
                    {label: "September 2022", value:"0"},
                    {label: "October 2022", value: "1"},
                    {label: "November 2022", value: "2"},
                    {label: "December 2022", value: "3"},
                    {label: "January 2023", value: "4"},
                    {label: "February 2023", value: "5"},
                    {label: "March 2023", value: "6"},
                    {label: "April 2023", value: "7"},
                    {label: "May 2023", value: "8"},
                    {label: "June 2023", value: "9"},
                    {label: "July 2023", value: "10"},
                    {label: "August 2023", value: "11"},
                    {label: "September 2023", value: "12"},
                    {label: "November 2023", value: "13"},
                    {label: "January 2024", value: "14"},
                    {label: "February 2024", value: "15"},
                    {label: "March 2024", value: "16"},
                    {label: "May 2024", value: "17"},
                    {label: "July 2024", value: "18"},
                    {label: "August 2024", value: "19"},
                    {label: "October 2024", value: "20"},
                ]} />

                <Select label="Only show the following data:" mb="md" value={dataset} onChange={(val) => {setDataset(val)}} data={[
                    {label: "SMEs Receing Loans", value:"0"},
                    {label: "SMEs receiving TA", value: "1"},
                    {label: "Show All", value: "all"}
                ]} />

            <Text mb="md" style={{textDecoration: 'underline'}}>Legend</Text>
            <Group>
              <ColorSwatch size={15} color="rgba(248, 148, 6, 1)" />
              <Text>SMEs Receiving Loans</Text>
            </Group>
            <Group>
              <ColorSwatch size={15} color="rgba(77, 5, 252, 1)" />
              <Text>SMEs Receiving TA</Text>
            </Group>
            <Group>
              <ColorSwatch size={15} color="green" />
              <Text>Protected Areas</Text>
            </Group>

            <Group mb="md">
              <ColorSwatch size={15} color={theme.colorScheme === "light" ? "black" : "white"} />
              <Text>Country Boundaries</Text>
            </Group>

            <Text mb="md" style={{textDecoration: 'underline'}}>Datasets Download</Text>
            <List center >
                <List.Item><Anchor href={`${PUBLIC_URL}/aceli/dashboard/datasets/smes-receiving-loans.geojson`} >SMEs Receiving Loans(GeoJSON)</Anchor></List.Item>
                <List.Item><Anchor href={`${PUBLIC_URL}/aceli/dashboard/datasets/smes-receiving-ta.geojson`} >SMEs Receiving TA(GeoJSON)</Anchor></List.Item>
                <List.Item><Anchor href={`${PUBLIC_URL}/aceli/dashboard/datasets/ProtectedAreas.zip`} >Protected Areas(SHP)</Anchor></List.Item>
                <List.Item><Anchor href={`${PUBLIC_URL}/aceli/dashboard/datasets/CountryBoundaries.zip`} >Country Boundaries(SHP)</Anchor></List.Item>
            </List>

          </Aside>
        </MediaQuery>
      }
      navbar={
        <Navbar p={0} style={{borderRight: 0}} hiddenBreakpoint="sm" hidden={!opened} width={{ sm: 300, lg: 300 }}>

        <Paper mb={20} mt={10} withBorder shadow="md" p={"xs"}>
            <Center mb={20}>
                <Text>Stats Summary</Text>
            </Center>
        <SimpleGrid cols={1}>
            <Group>
            <RingProgress
            size={80}
            roundCaps
            thickness={4}
            sections={[{ value: ((sme / (sme + ta)) * 100).toFixed(0), color: 'rgba(248, 148, 6, 1)' }]}
            label={
              <Center>
                <Text>{((sme / (sme + ta)) * 100).toFixed(0) + "%"}</Text>
              </Center>
            }
          />
          <Center>
            <Text size="sm" >SMEs Receiving Loans</Text>
            </Center>
            </Group>
            <Group>
            <RingProgress
            size={80}
            roundCaps
            thickness={4}
            sections={[{ value: ((ta / (sme + ta)) * 100).toFixed(0), color: 'rgba(77, 5, 232, 1)' }]}
            label={
              <Center>
                <Text>{((ta / (sme + ta)) * 100).toFixed(0) + "%"}</Text>
              </Center>
            }
          />
            <Center>
            <Text  size="sm" >SMEs Receiving TA</Text>
            </Center>
            </Group>
        </SimpleGrid>
        </Paper>

        <Paper mb={20} p="xs" withBorder shadow="md">
            <Center mb={20}>
                <Text>SMEs Country Distribution</Text>
            </Center>
            <ConsumptionChart />
        </Paper>

        <Paper mb={20} p="xs" withBorder shadow="md">
            <Center mb={20}>
                <Text>SMEs Months Comparison</Text>
            </Center>
            <PreviousChart />
        </Paper>
        </Navbar>
      }
    >
      <MapLayer />
    <Paper style={{height: height * 0.2, overflowY: "auto"}} mt={5} p="xs" withBorder shadow="md">
            <Center mb={5}>
                <Text>Average Nearest Distance to Protected Areas(Per Country)</Text>
            </Center>
            <Group position='apart'>
            <div>
            <RingProgress
            size={60}
            roundCaps
            thickness={4}
            sections={[{ value: (parseFloat(ke2) / (parseFloat(ke2)+ parseFloat(ke3))) * 100, color: 'rgba(248, 148, 6, 1)' }, {value: (parseFloat(ke3) / (parseFloat(ke2) + parseFloat(ke3))) * 100, color: 'rgba(77, 5, 232, 1)'}]}
            label={
              <Center>
                <Text >Ke</Text>
              </Center>
            }
          />
          <div>
          <Text size={"xs"} ><strong>Loans: {` ${ke2}`}KM</strong></Text>
          <Text size={"xs"} >TA: <strong>{`${ke3}`}KM</strong></Text>
          </div>
            </div>

            <div>
            <RingProgress
            size={60}
            roundCaps
            thickness={4}
            sections={[{ value: (parseFloat(ug2) / (parseFloat(ug2) + parseFloat(ug3))) * 100, color: 'rgba(248, 148, 6, 1)' }, {value: (parseFloat(ug3) / (parseFloat(ug2) + parseFloat(ug3))) * 100, color: 'rgba(77, 5, 232, 1)'}]}
            label={
              <Center>
                <Text >Ug</Text>
              </Center>
            }
          />
          <div>
          <Text size={"xs"}>Loans: <strong>{`${ug2} `}KM</strong></Text>
                <Text size={"xs"}>TA: <strong>{`${ug3}`}KM</strong></Text>
            </div>
            </div>

            <div>
            <RingProgress
            size={60}
            roundCaps
            thickness={4}
            sections={[{ value: (parseFloat(tz2 ) / (parseFloat(tz2) + parseFloat(tz3))) * 100, color: 'rgba(248, 148, 6, 1)' }, {value: (parseFloat(tz3) / (parseFloat(tz2) + parseFloat(tz3))) * 100, color: 'rgba(77, 5, 232, 1)'}]}
            label={
              <Center>
                <Text >Tz</Text>
              </Center>
            }
          />
          <div>
          <Text size={"xs"}>Loans: <strong>{`${tz2} `}KM</strong></Text>
                <Text size={"xs"}>TA: <strong>{`${tz3}`}KM</strong></Text>
            </div>
            </div>

            <div>
            <RingProgress
            size={60}
            roundCaps
            thickness={4}
            sections={[{ value: (parseFloat(rw2) / (parseFloat(rw2) + parseFloat(rw3))) * 100, color: 'rgba(248, 148, 6, 1)' }, {value: (parseFloat(rw3) / (parseFloat(rw2) + parseFloat(rw3))) * 100, color: 'rgba(77, 5, 232, 1)'}]}
            label={
              <Center>
                <Text >Rw</Text>
              </Center>
            }
          />
          <div>
          <Text size={"xs"}>Loans: <strong>{`${rw2} `}KM</strong></Text>
                <Text size={"xs"}>TA: <strong>{`${rw3}`}KM</strong></Text>
            </div>
            </div>

            <div>
            <RingProgress
            size={60}
            roundCaps
            thickness={4}
            sections={[{ value: (parseFloat(zam2) / (parseFloat(zam2) + parseFloat(zam3))) * 100, color: 'rgba(248, 148, 6, 1)' }, {value: (parseFloat(zam3) / (parseFloat(zam2) + parseFloat(zam3))) * 100, color: 'rgba(77, 5, 232, 1)'}]}
            label={
              <Center>
                <Text >ZM</Text>
              </Center>
            }
          />
          <div>
          <Text size={"xs"}>Loans: <strong>{`${rw2} `}KM</strong></Text>
                <Text size={"xs"}>TA: <strong>{`${rw3}`}KM</strong></Text>
            </div>
            </div>
            </Group>
        </Paper>
    </AppShell>
  );
}
